import UserEditForm from "./user-edit-form";

export default UserEditForm;